import React from 'react'
import ClientInformationForm from '../components/forms/ClientInformationForm'

const ClientInformation = () => {
  return (
    <>
      <h6 className='font-bold text-gray-600 md:mb-3 mb-2 xl:text-4xl md:text-3xl text-2xl'>
        ¡Bienvenido a Impacta - Emprendimiento sostenible!
      </h6>
      <p className='text-gray-600 text-base xl:text-xl sm:text-lg text-base'>
        Impactemos juntos para lograr un mundo mejor. Tú con tus ideas, tus ganas, tu talento... Nosotros con nuestras ideas, nuestro conocimiento, nuestros recursos, nuestros nexos.
      </p>
      <p className='text-gray-500  text-base xl:text-xl sm:text-lg text-base mt-5'>
        Queremos conocer más de ti...
      </p>
      <div className='flex flex-wrap -mx-3 mb-6 p-10'>
        <div className='w-full'>
          <ClientInformationForm />
        </div>
      </div>
    </>
  )
}

export default ClientInformation
